import { DatePipe } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import {
  Combo2Service,
  ComboService,
  DesignphotoService,
  SalesOrderService,
} from "../../../services/index";

@Component({
  selector: "addEdit-SalesOrder",
  templateUrl: "./addEditSalesOrder.html",
  // encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddEditSalesOrder {
  row: any;
  data: any;
  designdata: any = {};
  sizeCol:any = '';
  designTypeList = ["GANG", "NEW", "PLAIN"];
  wodata: any = {
    shirtdno: "",
    party_code: "UNIT 1",
    party_name: "SKT CLOTHING CO",
    halfrate: 0,
    fullrate: 0,
    totalrate: 0,
  };
ratio_data: any = [
 {
    style: '',
    variety: '',
    varietyList: [],
    f_36: 0,
    f_38: 0,
    f_40: 0,
    f_42: 0,
    f_44: 0,
    f_46: 0,
    h_36: 0,
    h_38: 0,
    h_40: 0,
    h_42: 0,
    h_44: 0,
    h_46: 0
}
];



// varietyList = [];
  qualityList: any;
  typeList = ["Order Form", "Open Order"];
  // styleList = ["FORMAL", "PLAIN FORMAL", "CASUAL", "PEARL"];
  styleList = ["FORMAL", "CASUAL", "RR FORMAL", "RR CASUAL", "CLUB"];
  sleeveList = ["F/S", "H/S"]
  colorList: any;
  designnoList = [];
  tempDesignnoList = [];
  codeList: any;
  widthList: any[];
  agentList = [];
  Delivery: boolean = false;
  headerShow: boolean = true;
  onsaveDisable: boolean = false;
  partyList = [];
  seasonList = [];
  shirttypeList = [];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  salesdata: any = {
    entry_type: "Pcs",
    rc_no: "",
    dead_stk: "No",
    wo_type: "Sales",
    stk_pcs: "",
    file_name: "",
    order_type: "",
    fullQty: 0,
    halfQty: 0,
    f_36: "0",
    f_38: "0",
    f_40: "0",
    f_42: "0",
    f_44: "0",
    f_46: "0",
    h_36: "0",
    h_38: "0",
    h_40: "0",
    h_42: "0",
    h_44: "0",
    h_46: "0",
    design_no: "",
    f_design_no: "",
    h_design_no: ""
  };

  designList : any = [
    {
      design_no: "",
      design_type: "NEW",
      shade: "",
      typeid: "",
      type: "",
      rangefrom: "",
      rangeto: "",
      variety: "",
      fullQty: 0,
      halfQty: 0,
      color: "",
      fqty: 0,
      f36: 0,
      f38: 0,
      f40: 0,
      f42: 0,
      f44: 0,
      f46: 0,
      hqty: 0,
      h36: 0,
      h38: 0,
      h40: 0,
      h42: 0,
      h44: 0,
      h46: 0,
      full_set: "",
      half_set: "",
      full_size: "",
      half_size: "",
      totqty: 0,
      design_id: 0,
      design_ind: 0
    },
  ];

    designRow : any = {
      design_no: "",
      design_type: "NEW",
      shade: "",
      color: "",
      typeid: "",
      type: "",
      rangefrom: "",
      rangeto: "",
      variety: "",
      fullQty: 0,
      halfQty: 0,
      fqty: 0,
      f36: 0,
      f38: 0,
      f40: 0,
      f42: 0,
      f44: 0,
      f46: 0,
      hqty: 0,
      h36: 0,
      h38: 0,
      h40: 0,
      h42: 0,
      h44: 0,
      h46: 0,
      full_set: "",
      half_set: "",
      full_size: "",
      half_size: "",
      totqty: 0,
      design_id: 0,
      design_ind: 0
    };
  mode: string;
  saveEvent: any;
  // agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);

    this.salesdata = designdata;
    if (this.mode == "Edit") {

      this.salesdata.entry_type = "Pcs";
      this.salesdata.rc_no = "";
      this.salesdata.dead_stk = "No";
      this.salesdata.wo_type = "Sales";
      this.salesdata.stk_pcs = "";
      this.salesdata.file_name = "";
      this.salesdata.so_date = this.datePipe.transform(
        this.salesdata.so_date,
        "yyyy-MM-dd"
      );
   
      this.loaddesignList(this.salesdata.so_id, this.salesdata.order_type);
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private salesservice: SalesOrderService,
    private comboservice: ComboService,
    private designservice: DesignphotoService,
    private combo: Combo2Service,
    private change: ChangeDetectorRef
  ) {
    this.row = {
      design_no: "",
      design_type: "NEW",
      type: "",
      typeid: "",
      rangefrom: "",
      rangeto: "",
      color: "",
      f36: 0,
      f38: 0,
      f40: 0,
      f42: 0,
      f44: 0,
      f46: 0,
      fqty: 0,
      hqty: 0,
      h36: 0,
      h38: 0,
      h40: 0,
      h42: 0,
      h44: 0,
      h46: 0,
      totqty: 0,
    };
  }
  ngOnInit() {
    this.tableScroll();
    // this.setSetwiseData(0);
    if (this.mode == "Add") {
      // this.salesdata.so_date = this.datePipe.transform(
      //   new Date(),
      //   "yyyy-MM-dd"
      // );
      // this.getAuto();
    }
    this.getPartyList();
    this.getSeasonList();
    this.getTypeList();
    this.agentCombo();
    this.getDesignNoList();
  }

  tableScroll() {
    $(".workorderbody").height(window.innerHeight - 400);
    $(".workorderbody").width(window.innerWidth - 30);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#date").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {

    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      if (this.salesdata.order_type == "Open Order") {

        nextEl = "type-0";
      }
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  showNext(){
    this.headerShow = !this.headerShow;
  }
  getVarietyList(ind) {
   let style = this.ratio_data[ind].style
 
   this.ratio_data[ind].variety ='';

    this.combo.varietyStylePoCombo({ style: style, page: 'Rack Allocation' }).then((res: any) => {

      let list = [...res.data];

      this.ratio_data[ind].varietyList = list.reduce((unique, o) => {
        if (!unique.some(obj => obj.variety === o.variety)) {
          unique.push(o);
        }
        return unique;
      }, []);

    });

  }

  agentCombo() {
    let that = this;

    this.combo.agentCombo().then((res: any) => {
      that.agentList = res.data;
      // setTimeout(function () {
      //     that.displayAgent('Agent', that.user.params.agent_id);
      // }, 200);
    });
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      shade = this.designList[ind]["shade"],
      color = this.designList[ind]["color"],
      f36 = this.designList[ind].f36,
      f38 = this.designList[ind].f38,
      f40 = this.designList[ind].f40,
      f42 = this.designList[ind].f42,
      f44 = this.designList[ind].f44,
      f46 = this.designList[ind].f46,
      h36 = this.designList[ind].h36,
      h38 = this.designList[ind].h38,
      h40 = this.designList[ind].h40,
      h42 = this.designList[ind].h42,
      h44 = this.designList[ind].h44,
      h46 = this.designList[ind].h46,
      totqty = this.designList[ind]["totqty"];

    let nxtRow = $("#row-" + ind).next("tr");
    // let data = this.isRowEmpty(ind);
    if (fld == "design_type" && nxtRow.length == 0) {
      let len = this.designList.length;
      let design_type = this.designList[len - 1].design_type;
      if (design_type != "") {
        let design: any = this.designList[ind].design_no
        if (isNaN(design)) {
     
          for (let i = 0; i < this.designList.length; i++) {
            if (ind + 1 == this.designList.length) {
              this.row.design_type = this.designList[len - 1].design_type;
              let rowdetail = Object.assign({}, this.designList[len - 1]);
              rowdetail.color = '';
              rowdetail.shade = '';
              rowdetail.design_id = 0;
              rowdetail.design_no = '';
              rowdetail.variety = '';
              rowdetail.type = '';
              rowdetail.typeid = '';
              rowdetail.rangefrom = "",
              rowdetail.rangeto = "",
              this.designList.push(rowdetail);
              nxtInd = this.designList.length - 1;

            }
          }
        }
        else {
          this.row = {
            design_no: "",
            design_type: "NEW",
            type: "",
            typeid: "",
            rangefrom: "",
            rangeto: "",
            color: "",
            f36: 0,
            f38: 0,
            f40: 0,
            f42: 0,
            f44: 0,
            f46: 0,
            fqty: 0,
            hqty: 0,
            h36: 0,
            h38: 0,
            h40: 0,
            h42: 0,
            h44: 0,
            h46: 0,
            totqty: 0,
            design_ind: 0
          };
          this.designList.push(this.row);

        }
        setTimeout(() => {
          $("#" + "design_no" + "-" + (nxtInd + 1)).focus();
        }, 200);
        this.calcRate();
      }
      if (this.salesdata.order_type == "Open Order") {
        for (let i = 0; i < this.designList.length; i++) {
          if (ind + 1 == this.designList.length) {
            let rowdetail = Object.assign({}, this.row);
            // console.log(rowdetail,"Check 2")
            this.designList.push(rowdetail);

            nxtInd = this.designList.length - 1;
            fld = "type";
          }
        }
      }
    } else if (
      fld == "f36" ||
      fld == "f38" ||
      fld == "f40" ||
      fld == "f42" ||
      fld == "f44" ||
      fld == "f46"
    ) {
      $("#" + fld + "-" + nxtInd).select();
    } else if (
      fld == "h36" ||
      fld == "h38" ||
      fld == "h40" ||
      fld == "h42" ||
      fld == "h44" ||
      fld == "h46"
    ) {
      $("#" + fld + "-" + nxtInd).select();
    }
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);

  }
addNewRatioRow() {
    this.ratio_data.push( {
    style: '',
    variety: '',
    f_36: 0,
    f_38: 0,
    f_40: 0,
    f_42: 0,
    f_44: 0,
    f_46: 0,
    h_36: 0,
    h_38: 0,
    h_40: 0,
    h_42: 0,
    h_44: 0,
    h_46: 0
});
}

removeRatioRow(index: number) {
    if (this.ratio_data.length > 1) {
        this.ratio_data.splice(index, 1);
    }
}

getRowTotal(ratio: any, type: string): number {
    return Object.keys(ratio)
        .filter(key => key.startsWith(type + '_'))
        .reduce((sum, key) => sum + (Number(ratio[key]) || 0), 0);
}

getNextFieldId(currentSize: string, currentIndex: number): string {
    const sizes = ['f_34', 'h_34', 'f_36', 'h_36', 'f_38', 'h_38', 'f_40', 'h_40', 'f_42', 'h_42', 'f_44', 'h_44'];
    const currentPos = sizes.indexOf(currentSize);
    
    if (currentPos < sizes.length - 1) {
        return sizes[currentPos + 1] + '_' + currentIndex;
    } else if (currentIndex < this.ratio_data.length - 1) {
        return sizes[0] + '_' + (currentIndex + 1);
    } else {
        return 'design_type-0';
    }
}
  loaddesignList(id, order_type) {
    let params = {
      so_id: id,
      order_type: order_type,
      page: 1,
      start: 0,
      limit: 100,
    };
    this.salesservice.getSoEntryGridShirtSizeDet(params).then((res: any) => {
      this.designList = res.soListRes;
        this.ratio_data = res.ratio_data;
      this.ratio_data.forEach(e => {
        e.varietyList = JSON.parse(e.varietyList || '[]');
      });
      if (res.otherDetails) {
        this.designList[0]["type"] = res.otherDetails[0].type;
        this.designList[0]["rangefrom"] = res.otherDetails[0].rangefrom;
        this.designList[0]["rangeto"] = res.otherDetails[0].rangeto;
        this.designList[0]["halfQty"] = res.otherDetails[0].halfQty;
        this.designList[0]["fullQty"] = res.otherDetails[0].fullQty;
      }
      this.Delivery = res.Delivery;

      this.calcRate();
      this.calcRatioTot();
      this.change.detectChanges();
      // var length = res.length;
      // if(length >= 10){
      //     let i = 0;
      //        for(i;i<10;i++){
      //         this.designList.push(res[i]);
      //        }
      //       i = 10;
      //       let len = length - 10;
      //        for(i;i<len;i=i+10){
      //            if(i%10==0){
      //              this.doSetTimeout(res,i);
      //            }
      //            else{
      //                let temp = i%10;
      //                temp = temp+i;
      //             for( i;i<temp;i++)
      //             this.designList.push(res[i+temp]);
      //         }
      //            }

      //        }
      //    else{
      //        this.designList =res;
      //    }
    });
  }
  doSetTimeout(res, i) {
    i = i + 1;
    setTimeout(() => {
      for (var k = 0; k < 10; k++) {
        this.designList.push(res[i + k]);
      }
    }, 500);
  }
  calcTotal(event, ind, fld) {

    if (this.salesdata.order_type == "Order Form" && this.salesdata.style && !this.designList[ind].color) {
      swal("ERROR", "select the color First!!", "error");
      (document.getElementById(`${fld}-${ind}`) as HTMLInputElement).value = '';
      this.designList[ind][fld] = 0;
      return

    }

    let nan = function (no) {
      if (no == "" || no == null || no == undefined) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    };

    let item = this.designList[ind];
    // if(this.mode=='Add'){
    /*  item.f36!=""?parseInt(item.f36):0;
            item.f38!=""?parseInt(item.f38):0;
            item.f40!=""?parseInt(item.f40):0;
            item.f42!=""?parseInt(item.f42):0;
            item.f44!=""?parseInt(item.f44):0;
            item.h36!=""?parseInt(item.h36):0;
            item.h38!=""?parseInt(item.h38):0;
            item.h40!=""?parseInt(item.h40):0;
            item.h42!=""?parseInt(item.h42):0;
            item.h44!=""?parseInt(item.h44):0;*/
    let fqty =
      Number(item.f36) +
      Number(item.f38) +
      Number(item.f40) +
      Number(item.f42) +
      Number(item.f44) +
      Number(item.f46);
    let hqty =
      Number(item.h36) +
      Number(item.h38) +
      Number(item.h40) +
      Number(item.h42) +
      Number(item.h44) +
      Number(item.h46);
    this.designList[ind].fqty = Number(fqty);
    this.designList[ind].hqty = Number(hqty);
    this.designList[ind].totqty = Number(fqty) + Number(hqty);
    
    this.calcRate();
    /* }else{

            let f36 = parseInt(item.f36);
            let f38 : number = parseFloat(item.f38);
            let f40 : number = parseFloat(item.f40);
            let f42 : number = parseFloat(item.f42);
            let f44 : number = parseFloat(item.f44);
            let h36 : number = parseFloat(item.h36);
            let h38 : number = parseFloat(item.h38);
            let h40 : number = parseFloat(item.h40);
            let h42 : number = parseFloat(item.h42);
            let h44 : number = parseFloat(item.h44);

            let fqty =  f36+ f38+ f40 + f42 + f44;
            let hqty =  h36+ h38+ h40 +h42 + h44;
            this.designList[ind].fqty =fqty;
            this.designList[ind].hqty = hqty;
            this.designList[ind].totqty =  f36+ f38+ f40 + f42 + f44;
            this.calcRate();
        
        }
*/
  }

  // calcRate() {
  //   let item = this.designList;

  //   let fullrate = 0,
  //     halfrate = 0,
  //     totalrate = 0;
  //   for (let i = 0; i < item.length; i++) {
  //     fullrate += item[i].fqty;
  //     halfrate += item[i].hqty;
  //     if (isNaN(fullrate)) {
  //       halfrate = 0;
  //     }
  //     if (isNaN(halfrate)) {
  //       halfrate = 0;
  //     }
  //     totalrate = fullrate + halfrate;
  //   }

  //   this.wodata.fullrate = fullrate;
  //   this.wodata.halfrate = halfrate;
  //   this.wodata.totalrate = totalrate;
  // }

  calcRatioTot() {
   
    // Calculate ftot
    this.salesdata.f_tot =
      Number(this.ratio_data[0].f_36 || 0) +
      Number(this.ratio_data[0].f_38 || 0) +
      Number(this.ratio_data[0].f_40 || 0) +
      Number(this.ratio_data[0].f_42 || 0) +
      Number(this.ratio_data[0].f_44 || 0) +
      Number(this.ratio_data[0].f_46 || 0);

    // Calculate htot
    this.salesdata.h_tot =
      Number(this.ratio_data[0].h_36 || 0) +
      Number(this.ratio_data[0].h_38 || 0) +
      Number(this.ratio_data[0].h_40 || 0) +
      Number(this.ratio_data[0].h_42 || 0) +
      Number(this.ratio_data[0].h_44 || 0) +
      Number(this.ratio_data[0].h_46 || 0);

    this.salesdata.tot =   Number(this.salesdata.f_tot || 0) + Number(this.salesdata.h_tot || 0)

  }
  calcRate() {
    let item = this.designList;
  
    let fullrate = 0,
      halfrate = 0,
      totalrate = 0;
  
    // Initialize size-wise totals directly in this.wodata
    const sizeFields = ["f36", "f38", "f40", "f42", "f44", "f46", "h36", "h38", "h40", "h42", "h44", "h46"];
   
    // Initialize size fields to 0 in wodata
    sizeFields.forEach(size => {
      this.wodata[size] = 0;
    });
  
    for (let i = 0; i < item.length; i++) {
      fullrate += Number(item[i].fqty) || 0;
      halfrate += Number(item[i].hqty) || 0;
  
      // Sum up the individual size counts
      sizeFields.forEach(size => {
        this.wodata[size] += Number(item[i][size]) || 0; // Add current item's size count, default to 0 if undefined
      });
    }
  
    totalrate = fullrate + halfrate;
  
    // Assign overall rates to wodata
    this.wodata.fullrate = fullrate;
    this.wodata.halfrate = halfrate;
    this.wodata.totalrate = totalrate;

   this.setBackground();
  }
  setBackground() {

    this.designList = this.designList.map(item => ({
      ...item,
      isBackground: this.colorList.some(c => c.design_id === item.design_id)
    }));
  }
  

  isRowEmpty(ind) {
    let data = this.data.designList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  deleteRow(ind) {
    if (ind == 0) {
      this.designList[ind].f36 = 0;
      this.designList[ind].f38 = 0;
      this.designList[ind].f40 = 0;
      this.designList[ind].f42 = 0;
      this.designList[ind].f44 = 0;
      this.designList[ind].f46 = 0;
      this.designList[ind].fqty = 0;
      this.designList[ind].h36 = 0;
      this.designList[ind].h38 = 0;
      this.designList[ind].h40 = 0;
      this.designList[ind].h42 = 0;
      this.designList[ind].h44 = 0;
      this.designList[ind].h46 = 0;
      this.designList[ind].hqty = 0;
      this.designList[ind].half_set = '';
      this.designList[ind].full_set = '';
      this.designList[ind].totqty = 0;
      return
    }
    this.designList.splice(ind, 1);
  }

  onDeleteRow($event, fld, ind) {
    //     onDeleteRow(ind) {
    //  $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.designList.length > 1) {
          that.designList.splice(ind, 1);
          that.calcRate();
          if ($("#" + fld + "-" + (ind - 1)).length > 0) {
            $("#" + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + fld + "-" + (ind + 1)).length > 0) {
            $("#" + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) { }
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAuto() {
    let params = {
      trans_type: "SalesOrder",
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };

    this.salesservice.getAutoNumber(params).then((res: any) => {
      this.salesdata.so_no = res.auto_no;
      this.oncheckemptyrow();
    });
  }

  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }
  checkColor(design_id, ind) {
    // for (var k = 0; k < this.designList.length; k++) {
    //   let temp = this.designList[k];
    //   if (design_id > 0) {
    //     // if (temp.design_id == design_id && ind !== k) {
    //     //   swal("DESIGN AND COLOR ALREADY EXIST");
    //     //   this.designList[ind].design_no = "";
    //     //   this.designList[ind].color = "";
    //     //   this.designList[ind].design_id = 0;
    //     // }
    //   }
    // }
  }


  setSetwiseData(ind) {


    let design_ind = Math.max(...this.designList.map(item => item.design_ind)) + 1;

    let ind_flag = design_ind % 2 === 0 ? false : true;
    console.log("dessign_ind::", design_ind, "ind_flag:",ind_flag, this.designList[ind].design_id, "design Index Row", this.designList, ind)

    if (this.designList.some((temp) => temp.design_id === this.designList[ind].design_id && temp.design_ind && temp.design_ind !== design_ind)) {
      swal("ERROR", "DESIGN AND COLOR ALREADY EXISTS", "error");
    
      this.designList.splice(ind,1)
      return
    }

    // Helper function to convert "1/2" to 1 and other numbers to integers
    const convertValue = (value) => (value === "1/2" && ind_flag ? 1 : value === "1/2" && !ind_flag ? 0 : parseInt(value, 10));

    // Helper function to get the full_set and half_set
    const getFullAndHalfSets = (fields, main) => {
      let Set = "";
      // let halfSet = "";

      const calculateRange = (keys) => {
        let start = "";
        let end = "";
        let range = "";

        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          if (fields[key] > 0 && [`${main}36`, `${main}38`, `${main}40`, `${main}42`, `${main}44`, `${main}46`].includes(key)) {

            if (!start) start = key; // Mark the start of the range
            end = key; // Update the end of the range
          } else if (start && end) {
            // Finalize the range if a break occurs
            range = range ? `${range}, ${start}-${end}` : `${start}-${end}`;
            start = "";
            end = "";
          }
        }

        // Finalize any remaining range
        if (start && end) {
          range = range ? `${range}, ${start}-${end}` : `${start}-${end}`;
        }

        return range;
      };

      // Calculate ranges for `f_*` (full sizes) and `h_*` (half sizes)
      const SizeFields = Object.keys(fields).filter((key) => key.startsWith(main));
      // const halfSizeFields = Object.keys(fields).filter((key) => key.startsWith("h"));

      Set = calculateRange(SizeFields);
      // halfSet = calculateRange(halfSizeFields);

      return { Set };
    };


    // Process the data dynamically
    const processDynamicRows = (data, baseRow, field) => {
      const rows = [];
      let currentData = {};

      // Convert all relevant size fields in `data` to integers for processing
      for (const [key, value] of Object.entries(data)) {
        if (key.startsWith(field)) {
          currentData[key] = convertValue(value);

        }
      }

      // Loop until all size values are consumed
      while (Object.values(currentData).some((val: any) => val > 0)) {

        const newRow = { ...baseRow };

        // Include the additional fields from `data`
        newRow.order_by = data.order_by;
        newRow.party_id = data.party_id;
        newRow.style = data.style;

        let fqty = 0;
        let hqty = 0;

        for (const key of Object.keys(currentData)) {
          const [type, size] = key.split("_");
          if (currentData[key] > 0) {
            newRow[`${type}${size}`] += 1;
            currentData[key] -= 1;
            if (type === "f") fqty += 1;
            if (type === "h") hqty += 1;
          }


        }

        // Update quantities for the new row
        newRow.fqty = fqty;
        newRow.hqty = hqty;
        newRow.totqty = fqty + hqty;

        // Get the continuous full and half-size sets


        // Add the row to the result
        rows.push(newRow);
      }

      return rows;
    };
    let row: any = this.designList[ind];
    let resultRowsfull: any
    let resultRowsHalf: any
    let varietyRatio = this.ratio_data.find(e=> e.style == this.designList[ind].style && e.variety == this.designList[ind].variety)
    console.log("chcek varietyRatio", varietyRatio)
    // Generate rows dynamically

    if(!varietyRatio){
      swal("ERROR", `Ratio Not Exist for ${this.designList[ind].style}-${this.designList[ind].variety}`, "error")
      this.designList.splice(ind,1)
      return false;
    }

    resultRowsfull = processDynamicRows(varietyRatio, row, 'f_');

    resultRowsHalf = processDynamicRows(varietyRatio, row, 'h_');



    const rowIteration = (data, main, sub, setName) => {

      const sizeOrder = [
        `${main}36`, `${main}38`, `${main}40`, `${main}42`, `${main}44`, `${main}46`
      ];


      let totData: any;
      totData = {
        [`${main}36`]: 0, [`${main}38`]: 0, [`${main}40`]: 0, [`${main}42`]: 0, [`${main}44`]: 0, [`${main}46`]: 0
      };
      for (let j = 0; j < data.length; j++) {

        let result = {};
        for (let i = 0; i < sizeOrder.length; i++) {
          const currentSizeValue = data[j][sizeOrder[i]];  // Accessing size value in the current object
          const nextSizeValue = sizeOrder[i + 1] ? data[j][sizeOrder[i + 1]] : 0; // Checks if the next element exists
          const prevSizeValue = sizeOrder[i - 1] ? data[j][sizeOrder[i - 1]] : 0;



          if (currentSizeValue > 0 && !nextSizeValue && !prevSizeValue) {


            result[sizeOrder[i]] = currentSizeValue;


            // isContinuous = true;

          }
        }
        for (let key in result) {
          if (totData.hasOwnProperty(key)) {
            totData[key] += result[key];  // Set the value of the key in totData
            data[j][key] = 0;  // Set the value of the key in the current object to 0

          }
        }
        // console.log(j, result)

        data[j][`${main}qty`] = data[j][`${main}36`]
          +
          data[j][`${main}38`] +
          data[j][`${main}40`] +
          data[j][`${main}42`] +
          data[j][`${main}44`] +
          data[j][`${main}46`]
        data[j].totqty = data[j][`${main}qty`] || 0

        if (data[j].totqty > 0) {
          const { Set } = getFullAndHalfSets(data[j], main);
          data[j][setName] = Set ? Set : ''

        }
        else {
          data[j][setName] = ''
        }
      }
      totData.design_no = data[0].design_no,
        totData.design_type = 'NEW',
        totData.variety = data[0].variety,
        totData.style = data[0].design_no,
        totData.design_id = data[0].design_id,
        totData.color = data[0].color,
        totData[`${main}qty`] = totData[`${main}36`]
        +
        totData[`${main}38`] +
        totData[`${main}40`] +
        totData[`${main}42`] +
        totData[`${main}44`] +
        totData[`${main}46`]
      totData.totqty = totData[`${main}qty`] || 0
      totData[`${sub}qty`] = 0
      totData[setName] = ''
      // data.splice(ind, 1)
      data.push(totData)
      data = data.filter((el) => el.totqty > 0)
      return data;
    }
    resultRowsfull = resultRowsfull.length > 0 && (this.sizeCol == 'size' || this.sizeCol == 'f_size') ? rowIteration(resultRowsfull, 'f', 'h', 'full_set') : [];
    resultRowsHalf = resultRowsHalf.length > 0 && (this.sizeCol == 'size' || this.sizeCol == 'h_size')? rowIteration(resultRowsHalf, 'h', 'f', 'half_set') : [];



    function splitByFullSet(data, field, setName) {
      let result = [];

      data.forEach(row => {
        // If full_set is empty, keep the row as is
        if (!row[setName]) {
          result.push(row);
          return;
        }

        // Split the full_set field into multiple ranges
        let fullSets = row[setName].split(',').map(set => set.trim());

        fullSets.forEach(set => {
          let newRow = { ...row }; // Clone the row
          newRow[setName] = set;

          // Reset all size fields
          Object.keys(newRow).forEach(key => {
            if (key.startsWith(field) && key.length === 3) newRow[key] = 0;
          });

          // Extract start and end from range (e.g., "f36-f40")
          let [start, end] = set.split('-').map(size => parseInt(size.replace(field, '')));
          for (let i = start; i <= end; i += 2) {
            let sizeKey = `${field}${i}`;
            newRow[sizeKey] = row[sizeKey];
          }

          // Update the total quantity
          newRow.fqty = Object.keys(newRow)
            .filter(key => key.startsWith(field) && key.length === 3)
            .reduce((sum, key) => sum + newRow[key], 0);
          if (start === end) {
            newRow[setName] = "";
          }
          result.push(newRow);
        });
      });

      return result;
    }

    resultRowsfull = resultRowsfull.length > 0 ? splitByFullSet(resultRowsfull, "f", "full_set") : [];
    resultRowsHalf = resultRowsHalf.length > 0 ? splitByFullSet(resultRowsHalf, "h", "half_set") : [];


    // row.filter((el) => el.totqty > 0)
    resultRowsfull = Object.values(resultRowsfull.reduce((acc, item) => {
      // Check if the full_set and half_set already exist as keys
      const fullSet = item.full_set || "no_full_set";
      const halfSet = item.half_set || "no_half_set";

      const key = `${fullSet}}`; // Create a unique key combining both sets

      // If the key does not exist, initialize the item
      if (!acc[key]) {
        acc[key] = { ...item, fqty: item.f36 + item.f38 + item.f40 + item.f42 + item.f44 + item.f46, totqty: item.f36 + item.f38 + item.f40 + item.f42 + item.f44 + item.f46, h36: 0, h38: 0, h40: 0, h42: 0, h44: 0, h46: 0, hqty: 0 };
      } else {
        // Accumulate values for each matching full_set and half_set

        acc[key].f36 += item.f36;
        acc[key].f38 += item.f38;
        acc[key].f40 += item.f40;
        acc[key].f42 += item.f42;
        acc[key].f44 += item.f44;
        acc[key].f46 += item.f46;
        acc[key].hqty = 0;
        acc[key].h36 = 0;
        acc[key].h38 = 0;
        acc[key].h40 = 0
        acc[key].h42 = 0
        acc[key].h44 = 0
        acc[key].h46 = 0
        acc[key].fqty += item.f36 + item.f38 + item.f40 + item.f42 + item.f44 + item.f46
        acc[key].totqty += item.fqty;
        acc[key].half_set = '';
      }

      return acc;
    }, {}));

    // console.log(groupedDataFull);


    resultRowsHalf = Object.values(resultRowsHalf.reduce((acc, item) => {
      // Check if the full_set and half_set already exist as keys
      const fullSet = item.full_set || "no_full_set";
      const halfSet = item.half_set || "no_half_set";

      const key = `${halfSet}}`; // Create a unique key combining both sets

      // If the key does not exist, initialize the item
      if (!acc[key]) {
        acc[key] = { ...item, ...item, hqty: item.h36 + item.h38 + item.h40 + item.h42 + item.h44 + item.h46, totqty: item.h36 + item.h38 + item.h40 + item.h42 + item.h44 + item.h46, f36: 0, f38: 0, f40: 0, f42: 0, f44: 0, f46: 0, fqty: 0 };
      } else {
        // Accumulate values for each matching full_set and half_set

        acc[key].h36 += item.h36;
        acc[key].h38 += item.h38;
        acc[key].h40 += item.h40;
        acc[key].h42 += item.h42;
        acc[key].h44 += item.h44;
        acc[key].h46 += item.h46;
        acc[key].fqty = 0;
        acc[key].f36 = 0;
        acc[key].f38 = 0;
        acc[key].f40 = 0
        acc[key].f42 = 0
        acc[key].f44 = 0
        acc[key].f46 = 0
        acc[key].hqty += item.h36 + item.h38 + item.h40 + item.h42 + item.h44 + item.h46
        acc[key].totqty += item.hqty;
        acc[key].full_set = '';
      }

      return acc;
    }, {}));



    let mergedArray: any = [];
    let maxLength = Math.max(resultRowsfull.length, resultRowsHalf.length);

    for (let i = 0; i < maxLength; i++) {
      let full = resultRowsfull[i] || {}; // Use empty object if full_set is missing an index
      let half = resultRowsHalf[i] || {}; // Use empty object if half_set is missing an index

      mergedArray.push({
        ...full,
        ...half,
        fqty: (full.fqty || 0) + (half.fqty || 0),
        hqty: (full.hqty || 0) + (half.hqty || 0),
        totqty: (full.totqty || 0) + (half.totqty || 0),
        f36: (full.f36 || 0) + (half.f36 || 0),
        f38: (full.f38 || 0) + (half.f38 || 0),
        f40: (full.f40 || 0) + (half.f40 || 0),
        f42: (full.f42 || 0) + (half.f42 || 0),
        f44: (full.f44 || 0) + (half.f44 || 0),
        f46: (full.f46 || 0) + (half.f46 || 0),
        h36: (full.h36 || 0) + (half.h36 || 0),
        h38: (full.h38 || 0) + (half.h38 || 0),
        h40: (full.h40 || 0) + (half.h40 || 0),
        h42: (full.h42 || 0) + (half.h42 || 0),
        h44: (full.h44 || 0) + (half.h44 || 0),
        h46: (full.h46 || 0) + (half.h46 || 0),
        full_set: full.full_set ? full.full_set.toUpperCase() : "",
        half_set: half.half_set ? half.half_set.toUpperCase() : "",
        full_size: full.full_set ? "" : full.fqty ? 'SIZES' : '',
        half_size: half.half_set ? "" : half.hqty ? 'SIZES' : '',
        design_ind: design_ind
      });
    }

    this.designList.splice(ind, 1);
  
    this.designList.push(...mergedArray)
  // this.designList = this.designList.filter(design => design.totQty !== 0);
    this.calcRate();
   
  }


  showModel(){
  $("#designpr").modal("show");
  }
    hideModel(){
  $("#designpr").modal("hide");
  }


  // The typeahead commits the highlighted match inside its own keyup handler, which
  // runs after this binding - so defer a tick and read the value it just selected
  // instead of the half-typed text that is still in the model right now.
  onSelectdesignEnter(field, ind, typeaheadRef: any) {
    setTimeout(() => {
      this.onSelectdesign(this.salesdata[field], ind, typeaheadRef);
    }, 0);
  }

  onSelectdesign(desno, ind, typeaheadRef: any) {

 

    let design_no ='';
    // console.log(event.target.value)
    if (this.salesdata.design_no) {
      this.sizeCol = 'size';  
    } else if (this.salesdata.f_design_no) {
      this.sizeCol = 'f_size';
    } else if (this.salesdata.h_design_no) {
      this.sizeCol = 'h_size';
    } else {
      this.sizeCol = '';
    }
    
    if (desno == "") {
      this.colorList = [];
    } else {
      let no = _.filter(this.designnoList, { design_no: desno });
      let id;
      let code = [];
      if (no.length > 0) {
        id = no[0]["des_id"];
        design_no = no[0]["design_no"];
      } else {
        // Not an exact list entry, so treat it as "<design no> <shade>" and split on the last space.
        let splitAt = desno.lastIndexOf(' ');
        let baseNo = splitAt > 0 ? desno.substring(0, splitAt) : '';
        let match = baseNo ? this.designnoList.find(e => e.design_no == baseNo) : null;
        if (!match) {
          swal("ERROR", "Enter Valid Design!!!", "error");
          return false;
        }
        id = match["des_id"];
        design_no = baseNo;
        code = desno.substring(splitAt + 1).split(',').map(s => s.trim());
      }
       console.log("check Design Data", id, design_no, code)
      if (!id) {
        swal("ERROR", "Enter Valid Design!!!", "error");
        return false;
      }
      let params = {
        des_id: id,
        design_no: design_no,
        page: "Sales",
        codeData : JSON.stringify(code)
      };

      this.designservice.getDesignColorList(params).then((res: any) => {
        let allowDes: boolean = false;

        this.colorList = res;
        if(!res.length){
          swal("ERROR", "Enter Valid Design/Shade!!!", "error");
          return false;
        }
       if (ind == 0) this.designList = [];

      let obj : any= {};
        if (this.colorList[0].des_type == 'PLAIN' || this.colorList[0].des_type == 'Core' || this.colorList[0].des_type == 'CORE') {
           obj = this.ratio_data.find(e => e.style == this.colorList[0].des_style && e.variety == this.colorList[0].variety)
          const sizes = [36, 38, 40, 42, 44, 46];
           
          if (!obj) {
            swal("ERROR", `Ratio Not Exist for ${this.colorList[0].des_style}-${this.colorList[0].variety}`, "error")
            return false;
          }

          for (let index = 0; index < this.colorList.length; index++) {

            if (this.designList.some((temp) => temp.design_id == this.colorList[index].design_id)) {
              swal("ERROR", "DESIGN AND COLOR ALREADY EXISTS", "error");
              return
            }

            const newDesignRow = {
              ...this.designRow, // Spread existing defaults
              design_id: this.colorList[index].design_id,
              variety: this.colorList[index].variety,
              style: this.colorList[index].des_style,
              shade: this.colorList[index].dispName,
              design_no: design_no,
              color: this.colorList[index].dispName,
              fullQty: 0,
              halfQty: 0,
              fqty: 0,
              f36: obj.f_36,
              f38: obj.f_38,
              f40: obj.f_40,
              f42: obj.f_42,
              f44: obj.f_44,
              f46: obj.f_46,
              hqty: 0,
              h36: obj.h_36,
              h38: obj.h_38,
              h40: obj.h_40,
              h42: obj.h_42,
              h44: obj.h_44,
              h46: obj.h_46,
            }
             

            // NEW LOGIC: Alternate 0/1 for any size field with value "1/2"
            const assignValue = index % 2 === 0 ? 1 : 0; // Even → 1, Odd → 0
            sizes.forEach(size => {
              if (newDesignRow[`f${size}`] === '1/2') {
                newDesignRow[`f${size}`] = assignValue;
              }
              if (newDesignRow[`h${size}`] === '1/2') {
                newDesignRow[`h${size}`] = assignValue;
              }
            });


               if (this.sizeCol == 'f_size') {
            const hasFSizeValue = sizes.some(size => Number(newDesignRow[`h${size}`]) > 0);
            if (hasFSizeValue) {
              sizes.forEach(size => newDesignRow[`h${size}`] = 0);
            }
          }

          if (this.sizeCol == 'h_size') {
            const hasHSizeValue = sizes.some(size => Number(newDesignRow[`f${size}`]) > 0);
            if (hasHSizeValue) {
              sizes.forEach(size => newDesignRow[`f${size}`] = 0);
            }
          }
            this.designList.push(newDesignRow); 
            this.calcTotal(event, this.designList.length - 1, '')
          }
        }
        else {
          for (let index = 0; index < this.colorList.length; index++) {

            const newDesignRow = {
              ...this.designRow, // Spread existing defaults
              design_id: this.colorList[index].design_id,
              variety: this.colorList[index].variety,
              style: this.colorList[index].des_style,
              shade: this.colorList[index].dispName,
              design_no: design_no,
              color: this.colorList[index].dispName
            };
       
            this.designList.push(newDesignRow); // Remove the spread operator
         

            this.setSetwiseData(this.designList.length - 1)
          }
        }

        this.change.detectChanges();
      });
      // typeaheadRef.control.setValue('');
        setTimeout(() => {
       typeaheadRef.control.setValue('');
       typeaheadRef.reset();
      }, 200);

      setTimeout(() => {
        const el = this.scrollContainer.nativeElement;
        el.scrollTop = el.scrollHeight;
      }, 300);

    }
  }
  onSelectDesignType(design_type) {

    if (design_type == 'NEW') {
      design_type = 'DESIGN';
    }
    else if (design_type == 'PLAIN') {
      design_type = 'PLAIN';
    }

    this.designnoList = this.tempDesignnoList.filter((el) => el.type == design_type);

  }
  onSelectType($event, ind) {
    this.designList[ind]["typeid"] = $event.item.id;
  }

  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
      type: "order",
    };
    this.comboservice.getCurrentSeason(params).then((res: any) => {
      if (res.success) {
        this.salesdata.season_name = res.data.season;
        let today = new Date();
        this.salesdata.season_year = today.getFullYear();
      } else {
        swal("PLEASE PUT THE SEASON FIRST!");
      }
    });
  }
  getTypeList() {
    let params = {};
    this.comboservice.gettypeList().then((res: any) => {
      this.shirttypeList = res;
    });
  }
  getDesignNoList() {
    let params = {};
    this.comboservice.getDesignCombo(params).then((res: any) => {
      this.designnoList = res;
      this.tempDesignnoList = res;
    });
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.partyList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { genLedid: id });
      return fitem["name"];
    }
    return "";
  }

  onSelectSeason($event) {
    this.salesdata.season_year = $event.season_year;
  }

  onSelectParty($event) {
    // Bound to both (typeaheadOnSelect), whose event carries the picked item, and
    // (keyup.enter), whose KeyboardEvent does not - fall back to the typed name.
    let typed = (this.salesdata.party_name || "").trim().toUpperCase();
    let party = $event && $event.item
      ? $event.item
      : this.partyList.find(e => (e.name || "").trim().toUpperCase() == typed);

    // Enter also fires while the party is still being typed, so there is
    // simply nothing to fill in yet.
    if (!party) {
      return false;
    }

    this.salesdata.party_id = party.genLedid;
    this.salesdata.agent_id = party.agent_id;
    let data = this.agentList.find(e => e.agent_id == party.agent_id)

    this.salesdata.order_by = data ? data["agent_name"] : "";
    // console.log(this.agentList,data)
    this.onEnterKeyPressed("season", "", "");
  }
  onSelectColor(design, color, ind) {
    if (isNaN(color)) {
      color = color.toUpperCase();
    }
    this.colorList.forEach((element) => {
      if (color == element.dispName) {
        //     this.designList[ind]['des_id'] = element.des_id;
        this.designList[ind]["design_id"] = element.design_id;
        this.designList[ind]["shade"] = element.dispName;
      }
    });
   
    if(isNaN(design)){

      if (this.designList.some((temp, k) => temp.design_id === this.designList[ind].design_id && k !== ind)) {
        swal("ERROR", "DESIGN AND COLOR ALREADY EXISTS", "error");
      
        this.designList[ind].design_id = 0;
          setTimeout(() => {
            $("#" + "variety" + "-" + (ind)).focus(); 
            this.designList[ind].color = "";
           }, 300);
      }
      
      return
    }
     this.setSetwiseData(ind)

  }

  onSelectItem($event, design, ind) {
    let design_no = _.filter(this.data.designList, {
      design_no: design.design_no,
      shade: design.shade,
    });

    if (design_no.length == 1) {
      this.onGoToNextFld($event, "quality", ind);
    } else {
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "ALREADY EXISTS",
        body: "Design with this shade Already Exists",
      });
      design.design_no = "";
      design.shade = "";
    }
  }

  oncheckemptyrow() {
    let design = this.designList;

    let desList = [];
    for (let i = 0; i < design.length; i++) {
      //  if(design[i].color){
      // if(this.salesdata.order_type !== 'Open Order'){

      desList.push(design[i]);
      //   }
      //  }
      // if(this.salesdata.order_type == 'Open Order'){
      //     desList.push(design[i]);
      // }
    }
    this.designList = desList;
    this.onSaveOrder();
  }

  onSaveOrder(): void {
    if (
      this.salesdata.party_name == undefined ||
      this.salesdata.season_name == undefined ||
      this.salesdata.order_type == undefined ||
      !this.salesdata.book_no || !this.salesdata.so_date || !this.salesdata.no_pages
    ) {
      swal("Make sure that all the details are entered!");
    } else {
      this.salesdata.entry_type = "Pcs";
      this.salesdata.rc_no = "";
      this.salesdata.dead_stk = "No";
      this.salesdata.wo_type = "Sales";
      this.salesdata.stk_pcs = "";
      this.salesdata.file_name = "";
      this.salesdata.book_nos = (this.salesdata.book_no || "").split(",");
      this.salesdata.book_no = this.salesdata.book_no || "";
      this.salesdata.order_by = this.salesdata.order_by || "";

      if (this.mode == "Add" || this.mode == "Edit") {
        this.salesdata.fullQty = this.wodata.fullrate || "";
        this.salesdata.halfQty = this.wodata.halfrate || "";
      }

      this.salesdata.remarks = this.salesdata.remarks || "";
      let params: any = Object.assign({}, this.salesdata);
      params["tabevent"] = undefined;
      params["mode"] = this.mode;
      params["soGrid"] = JSON.stringify(this.designList);
       params["ratioData"] = JSON.stringify(this.ratio_data);
      params["so_date"] = this.datePipe.transform(
        params["so_date"],
        "yyyy-MM-dd"
      );
      let that = this;
      that.isLoading = true;
      swal({
        title: "Are you sure to save this Order?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.onsaveDisable = true;
        that.salesservice
          .adduptSalesOrder(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.onsaveDisable = false;
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/salesOrder/addEditSalesOrder.ts